import React, { FC, ReactElement } from 'react';

import { Breakpoint, Dialog } from '@mui/material';

type Props = {
  children: ReactElement;
  open: boolean;
  onClose: () => void;
  fullWidth?: boolean;
  maxWidth?: Breakpoint;
};

const DialogWrapper: FC<Props> = ({ children, onClose, open, fullWidth = true, maxWidth = 'lg' }) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open} fullWidth={fullWidth} maxWidth={maxWidth}>
      {children}
    </Dialog>
  );
};

export default DialogWrapper;
